export type uuid = string;
export type url = string;

export type generic_value = string | ReadonlyArray<string> | number | undefined;

export namespace VeboxModels {

    export interface Company {
        country: string;
        currency: string;
        guid: uuid;
        name: string;
        oemOriented: boolean;
        parentCustomerOriented: boolean;
        parentGuid: uuid;
        parentTypeGuid: uuid;
        parentTypeName: string;
        typeGuid: uuid;
        typeName: string;
        visibleToParentCompany: boolean;
    }

    export interface Role {
        code: string;
        name: string;
        description: string;
        permissions: Permission[];
        visible: boolean;
    }

    export interface Permission {
        code: string;
        name: string;
        description: string;
    }

    export interface User {
        company: Company;
        email: string;
        enabled: boolean;
        guid: uuid;
        incompleteData: boolean;
        locale: string;
        name: string;
        /**
         * @deprecated The field should not be used
         */
        permissions: string[];
        phone: string;
        privacyPolicyOK: boolean;
        receiveEmailNotifications: boolean;
        receivePushNotifications: boolean;
        /**
         * @deprecated The field should not be used
         */
        roles: string[];
        rolesAndPermissions: Role[];
        surname: string;
        termsOfServiceOK: boolean;
        termsOfServiceRequired: boolean;
        timezone: string;
        username: string;
        visible: boolean;
        lastActivity: string;
    }

    export interface HierarchiesTree {
        hierarchyGuid: uuid;
        label: string;
        children: HierarchiesTree[];
    }

    export interface Device {
        guid: string,
        dataOwnerGuid: string,
        dataOwnerName: string,
        transferable: boolean,
        code: string,
        idDevice: number,
        model: DeviceModel,
        firmware: Firmware,
        hasBluetooth: boolean,
        hasWifi: boolean,
        cfStatus: string,
        targetTestLevel: number,
        telemetryStatus: string,
        supportingTests: boolean,
        supportingCalibration: boolean,
        logEnabled: boolean
    }

    export interface DeviceModel {
        guid: uuid;
        name: string;
        typeGuid: uuid;
        typeName: string;
        categoryGuid: uuid;
        categoryName: string;
        logo: url;
        configurable: boolean;
    }

    export interface Firmware {
        guid: string,
        build: number,
        version: string,
        testLevel: number,
        typeAppname: string,
        typeDescription: string,
        configurabilityVersion: string,
        typeGuid: string,
        firmware: {
            href: string
        }
    }

    export enum PackageStatus {
        CLAIMABLE = "CLAIMABLE",
        NOT_CLAIMABLE = "UNCLAIMABLE",
        ALREADY_YOURS = "ALREADY_YOUR",
        NOT_FOUND = "NOT_FOUND",
        BEING_CLAIMED = "CLAIM_IN_PROGRESS"
    }

    export interface Package {
        guid: uuid;
        code: string;
        status: PackageStatus;
        deviceQuantity: number;
        deviceModel: DeviceModel;
    }

    export interface Locale {
        name: string;
        displayName: string;
    }

    export interface JSONEquipment {
        core: Equipment,
        telemetryDeviceInstallation: unknown,
        equipmentInstallation: EquipmentInstallation
    }

    interface Equipment {
        guid: string,
        dataOwnerGuid: string,
        dataOwnerName: string,
        customerCode: {
            code: string
        },
        manufacturerCode: {
            code: string
        },
        name: string,
        model: EquipmentModel
    }

    export interface EquipmentInstallation {
        equipment: Equipment,
        plant: Plant,
        installationDate: string
    }

    export interface EquipmentModel {
        id: number;
        category: string
        categoryGuid: string
        categoryImage: string
        coffeeMachine: boolean
        customGuid: string
        customImageGuid: string
        customName: string
        dummy: boolean
        generic: boolean
        guid: string
        manufacturerName: string
        name: string
        saleUnitOfMeasure: string
        type: string
        typeGeneric: boolean
        typeGuid: string
        typeImage: string
    }


    export interface Plant {
        guid: string,
        description: string,
        type: {
            guid: string,
            name: string,
            dummy: boolean
        },
        location: Location,
        telemetrySetupCompleted: boolean,
        telemetrySetupLastUpdate: string,
        telemetrySetupAuto: boolean
    }

    export interface LocationV7 {
        core: Location,
    }

    export interface Location {
        guid: string,
        dataOwnerGuid: string,
        dataOwnerName: string,
        type: LocationType,
        timezoneName: string,
        address: LocationAddress,
        geoPosition: {
            latitude: number,
            longitude: number,
            precision: number
        },
        code: string,
        description: string,
    }

    interface LocationAddress {
        street: string,
        zipCode: string,
        city: string,
        province: string,
        region: string,
        country: string,
        fullAddress: string
    }

    interface LocationType {
        guid: string,
        name: string,
        category: string,
        categoryGuid: string,
        dummy: boolean
    }

}